import { deleteConversationsFromTable } from './deleteConversations';
import { deleteItemsFromTable } from './deleteItems';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
export default function deleteMailListRows(rowKeys, originalTableViewId, isExplicitSoftDelete, actionSource) {
    var tableView = listViewStore.tableViews.get(originalTableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            deleteConversationsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
        case 1 /* Message */:
            deleteItemsFromTable(rowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource);
            break;
    }
}
//# sourceMappingURL=deleteMailListRows.js.map